import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = { class: "container-fluid" };
var _hoisted_2 = { class: "row" };
var _hoisted_3 = { class: "header-inner d-flex justify-content-between align-items-center" };
var _hoisted_4 = {
    key: 0,
    class: "btn btn-light",
    "data-bs-toggle": "offcanvas",
    "data-bs-target": "#sidebar",
    "aria-controls": "sidebar"
};
var _hoisted_5 = {
    key: 1,
    class: "profile-menu d-flex align-items-center"
};
var _hoisted_6 = { class: "profile-menu-item" };
var _hoisted_7 = {
    key: 0,
    class: "contextual-menu-sb"
};
var _hoisted_8 = { class: "notifications-wrapper" };
var _hoisted_9 = ["onClick"];
var _hoisted_10 = { class: "date" };
var _hoisted_11 = { class: "profile-menu-item" };
var _hoisted_12 = { class: "menu-button" };
var _hoisted_13 = {
    key: 0,
    class: "profile-name ps-1"
};
var _hoisted_14 = { class: "profile-menu-item" };
import { useAuthStore } from '@/stores/authStore';
import { useRouter } from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ref } from 'vue';
import { dateFormat } from '@/utils/dateformat';
import { readNotifications } from '@/api/auth';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Header',
    setup: function (__props) {
        var auth = useAuthStore();
        var router = useRouter();
        var showNotif = ref(false);
        function logout() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, auth.logout()];
                        case 1:
                            _a.sent();
                            router.push({ name: 'Login' });
                            return [2 /*return*/];
                    }
                });
            });
        }
        function toggleNotifications() {
            showNotif.value = !showNotif.value;
        }
        function openNotif(nid) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, readNotifications(nid)];
                        case 1:
                            _a.sent();
                            auth.fetchUser();
                            return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_unref(auth).isAuthenticated)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_4, [
                                _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'bars'] })
                            ]))
                            : _createCommentVNode("", true),
                        (_unref(auth).isAuthenticated)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", {
                                        class: "menu-button",
                                        onClick: toggleNotifications
                                    }, [
                                        _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'bell'] })
                                    ]),
                                    (showNotif.value === true)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Notificaciones", -1)),
                                            _createElementVNode("div", _hoisted_8, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(auth).user.notifications, function (not) {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass({ 'notif-item': true, 'new': not.readedAt === null }),
                                                        onClick: function ($event) { return (openNotif(not.id)); }
                                                    }, [
                                                        _createElementVNode("h5", null, _toDisplayString(not.title), 1),
                                                        _createElementVNode("p", null, [
                                                            _createTextVNode(_toDisplayString(not.body) + " - ", 1),
                                                            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(dateFormat)(not.createdAt, 'HH:mm DD/MMM')), 1)
                                                        ])
                                                    ], 10, _hoisted_9));
                                                }), 256))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'user-circle'] })
                                    ]),
                                    (_unref(auth).user !== null)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(auth).user.username), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("button", {
                                        class: "btn btn-light menu-button",
                                        onClick: logout
                                    }, [
                                        _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'sign-out-alt'] })
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
